<!--Grid of months and days per that month-->
<div class="d-flex flex-column border-bottom border-start border-end rounded-top h-100 shadow-sm">
  <div class="d-grid calendar__day-headers">
    <ng-container *ngFor="let month of dates">
      <!--Month-->
      <div class="w-100 text-center border-bottom border-top p-2 bg-white">{{ month[0] | employeeDate: 'MMMM' | async | titlecase }}</div>
    </ng-container>
  </div>
  <div class="overflow-auto flex-grow-1">
    <div class="d-grid calendar__grid">
      <ng-container *ngFor="let month of dates; let i = index">
        <div class="d-grid w-100 calendar__month-container">
          <ng-container *ngFor="let day of month; let dayIndex = index">
            <!--Day entry-->
            <!-- prettier-ignore -->
            <div 
            #yearDayItem
            (mousedown)="mouseDownEvent($event)"
            (mouseup)="mouseUpEvent($event)"

            [class.cal--weekend]="(day.getDay() == 6 || day.getDay() == 0) && !settings?.disableWeekendsGrey"
            [class.cal--in-the-past]="day.getTime() < yesterday.getTime() && !settings?.disablePastDaysGrey"
            [class.cal--today]="DateUtil.sameDay(day, today) && !settings?.disableHighlightToday"
            [class.cal--selectable]="!settings?.disableDaySelect"

            class="d-grid h-100 calendar__day user-select-none">
            <span class="d-flex align-items-center justify-content-center border-end">{{ day.getDate() }}</span>
            <div class="d-flex gap-2 w-100 align-items-center p-1 overflow-auto">
              <ng-container *ngFor="let event of eventIndex?.at(i)?.at(dayIndex)">
                <!-- prettier-ignore -->
                <div 
                class="calendar__event px-2 py-1 rounded text-white cursor-pointer"
                [class.calendar__event--inactive]="event.startDate.getTime() < today.getTime()"
                [ngbTooltip]="(event.startDate | date: 'HH:mm')  + ' ' + event.label"
                (click)="eventClick.emit({ date: day, event: $event, calendar: this, context: event })">
                  <i  class="fas" [ngClass]="'fa-' + (event.faIcon ?? 'calendar')"></i>
                </div>
              </ng-container>
            </div>
            <div class="d-flex w-100 justify-content-center align-items-center border-start"></div>
          </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #dayTemplate let-calendarDay="calendarDay"> </ng-template>
